// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__d6PCN","requiredAsterisk":"Info_requiredAsterisk__2fJiQ"};